var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:[
    `cv-dropdown-item ${_vm.carbonPrefix}--dropdown-item`,
    { [`${_vm.carbonPrefix}--dropdown--selected`]: _vm.internalSelected },
  ],attrs:{"data-option":"","data-value":_vm.value,"role":"menuitem"}},[_c('a',{ref:"link",class:`${_vm.carbonPrefix}--dropdown-link`,attrs:{"aria-checked":_vm.internalSelected,"href":"javascript:void(0)","role":"menuitemradio","tabindex":"-1"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }